






























import { Component, Vue } from "vue-property-decorator";

@Component
export default class EditPassword extends Vue {
  is_editing = false;
  has_been_edited = false;

  toggleEditingForm(): void {
    this.is_editing = !this.is_editing;
  }
}
